module.exports = __webpack_public_path__ + "static/img/Noel-Cleal.d0cbde1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Noel-Cleal.jpg
// module id = iACD
// module chunks = 0